"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertMeasure = void 0;
const is_measure_1 = require("../is-measure/is-measure");
const is_measure_with_value_1 = require("../is-measure-with-value/is-measure-with-value");
const conversionTable = new Map();
function convertMeasure(measure, targetUnit) {
    if (measure.unit === targetUnit) {
        return measure;
    }
    const currentEntry = conversionTable.get(measure.unit);
    const targetEntry = conversionTable.get(targetUnit);
    if (!currentEntry || !targetEntry) {
        throw new TypeError(`Unknown units: Cannot convert from '${measure.unit}' to '${targetUnit}'.`);
    }
    if (currentEntry.baseUnit !== targetEntry.baseUnit) {
        throw new TypeError(`Incompatible units: Cannot convert from '${measure.unit}' to '${targetUnit}'.`);
    }
    if (!(0, is_measure_with_value_1.isMeasureWithValue)(measure)) {
        return {
            ...measure,
            unit: targetUnit,
        };
    }
    return {
        ...measure,
        value: Math.round(measure.value * currentEntry.multiplier) / targetEntry.multiplier,
        unit: targetUnit,
    };
}
exports.convertMeasure = convertMeasure;
/**
 * Adds a new unit conversion. The base unit should be SI and not contain any prefix. Only measures with the same base
 * unit can be converted into each other.
 *
 * @param {string} baseUnit
 * @param {string} actualUnit
 * @param {number} multiplier
 */
convertMeasure.addUnit = function addUnit(baseUnit, actualUnit, multiplier) {
    conversionTable.set(actualUnit, { baseUnit, actualUnit, multiplier });
};
/**
 * Checks if a measure can be converted into another unit.
 *
 * @param {Measure|string} from
 * @param {string} to
 * @returns {boolean}
 */
convertMeasure.canConvert = function canConvert(from, to) {
    const currentEntry = conversionTable.get((0, is_measure_1.isMeasure)(from) ? from.unit : from);
    if (!currentEntry) {
        return false;
    }
    const targetEntry = conversionTable.get(to);
    if (!targetEntry) {
        return false;
    }
    return currentEntry.baseUnit === targetEntry.baseUnit;
};
const siPrefixes = [
    ['Y', 24],
    ['Z', 21],
    ['E', 18],
    ['P', 15],
    ['T', 12],
    ['G', 9],
    ['M', 6],
    ['k', 3],
    ['', 0],
    ['m', -3],
    ['μ', -6],
    ['n', -9],
    ['p', -12],
    ['f', -15],
    ['a', -18],
    ['z', -21],
    ['y', -24],
];
const units = ['m', 'A', 'g', 'Hz', 'N', 'Nm', 'Pa', 'J', 'W', 'Wh', 'V', 'Ω', 'l'];
for (const baseUnit of units) {
    for (const [prefix, exponent] of siPrefixes) {
        convertMeasure.addUnit(baseUnit, prefix + baseUnit, Math.pow(10, exponent));
    }
}
